module.exports = __webpack_public_path__ + "static/media/logo-new-white.017bb64a.png";